import { COMMON_FORM_FIELD_NAMES } from '../forms/constants';

const { noteDateCreated, noteFullName, noteContent } = COMMON_FORM_FIELD_NAMES;

// only Ids
export const FIELDS = {
	noteContent,
	noteDateCreated,
	noteFullName,
};
